<!-- <div class="pt-0"> -->

  <div class="row">
    <div class="col-md-9 pl-0 hd-clr-ovrde">
      <h5 class="mt-4 mb-3 heading">I- 9 Form Details for each Employee</h5>
    </div>
    <div class="col-md-3 search-btn pr-0">
      <div class="input-group mt-3 mb-3 search-text search-input-group">
        <input class="form-control rounded-pill im-pt-3 pr-5" type="search" #search (search)="resetSearch()"
          placeholder="Search Position / Company">
        <span class="input-group-append">
          <button class="btn rounded-pill ml-n4r p-0" type="button">
            <i class="fa fa-search border-0"></i>
          </button>
        </span>
      </div>
    </div>
  </div>

  <!-- <div class="tableDiv"> -->

   <!-- <div class="row">
      <div class="col-md-8 ">
        <h5 class="lbl-text mt-4">I-9 Details</h5>
      </div>
       <div class="col-md-4 mt-4 search-btn">
    <div class="input-group search-text">
      <input class="form-control rounded-pill im-pt-4 pr-5" type="search" #search (search)="resetSearch()"
          placeholder="Search Position / Company">
      <span class="input-group-append">
          <button class="btn rounded-pill ml-n4r p-0" type="button">
              <i class="fa fa-search border-0"></i>
          </button>
      </span>
  </div>
  </div> 
    </div>-->
    <div class="row">
      <div class="col-md-12 p-0">
        <div class="">
        <p-table id="table" [value]="beneficiaryList" dataKey="name" class="table-striped-odd border-0">
          <ng-template pTemplate="header">
            <tr>
              <th width="50px"></th>
              <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon>
              </th>
              <!-- <th pSortableColumn="positionDetails">Position Details <p-sortIcon field="positionDetails"></p-sortIcon>
              </th> -->
              <th pSortableColumn="intiatedDate">I-9 Initiation Date <p-sortIcon field="intiatedDate"></p-sortIcon>
              </th>
              <th pSortableColumn="employmentStart">Employment Start Date <p-sortIcon field="employmentStart">
                </p-sortIcon>
              </th>
              <th pSortableColumn="companyName">Company <p-sortIcon field="companyName"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-beneficiary let-expanded="expanded">
            <tr>
              <td>
                <button type="button" pButton pRipple [pRowToggler]="beneficiary"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></button>
              </td>
              <td>{{beneficiary.name}}</td>
              <!-- <td>{{beneficiary.positionDetails}}</td> -->
              <td>{{beneficiary.intiatedDate | date:'yyyy-MM-dd'}}</td>
              <td>{{beneficiary.employmentStart}}</td>
              <td>{{beneficiary.companyName}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-beneficiary>
            <tr>
              <td colspan="5">
                <div class="filesDiv">
                  <button class="btn btn-primary mb-2 float-left mr-3 btn-xs" (click)="showI9Form(beneficiary)">i-9
                    Form</button>
                  <button class="btn btn-primary mb-2 float-left mr-3 btn-xs">E-verify Confirmation</button>
                </div>
              </td>
            </tr>

          </ng-template>
        </p-table>
      </div>
      </div>
    </div>

    <div class="row justify-content-md-center">

      <p-paginator [rows]="pageSize" (onPageChange)="paginationEvent($event)" *ngIf="beneficiaryList?.length > 0"
        [totalRecords]="totalElementCount" [rowsPerPageOptions]="pageSizeOptions" length="totalElementCount">
      </p-paginator>

    </div>
  <!-- </div> -->